var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg__square",class:{'bg__square--green': _vm.isGreen}},[_c('svg-item',{attrs:{"src":"/assets/img/square-circles.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }